class ShippingCalculator {
  constructor() {
    this.form = document.querySelector('.shipping-calculator');
    if (!this.form) return;

    this.input = this.form.querySelector('#shipping-zip');
    this.button = this.form.querySelector('#calculate-shipping');
    this.result = this.form.querySelector('#shipping-result');

    this.button.addEventListener('click', () => this.calculate());
    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') this.calculate();
    });

    // Máscara simples de CEP
    this.input.addEventListener('input', () => {
      let v = this.input.value.replace(/\D/g, '').slice(0, 8);
      if (v.length > 5) v = v.slice(0, 5) + '-' + v.slice(5);
      this.input.value = v;
    });
  }
async calculate() {
  const zip = this.input.value.replace(/\D/g, '');
  if (zip.length !== 8) {
    this.showError('Digite um CEP válido.');
    return;
  }

  this.showLoading();
  const variantId = this.form.dataset.variantId;

  try {
    // 1. Busca estado via ViaCEP
    const cepData = await fetch(`https://viacep.com.br/ws/${zip}/json/`)
      .then(r => r.json());

    if (cepData.erro) {
      this.showError('CEP não encontrado.');
      return;
    }

    const province = cepData.uf; // ex: "RS", "SP", "RJ"

    // 2. Garante item no carrinho
    await this.ensureCartHasItem(variantId);

    // 3. Chama API do Shopify com province preenchido
    const response = await fetch(
      `/cart/shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=BR&shipping_address[province]=${province}`,
      { headers: { 'Content-Type': 'application/json' } }
    );

    if (!response.ok) {
      const err = await response.json();
      console.error('Shopify error:', err);
      throw new Error('Erro ao consultar frete.');
    }

    const data = await response.json();
    this.renderRates(data.shipping_rates);

  } catch (err) {
    this.showError(err.message || 'Não foi possível calcular o frete.');
    console.error(err);
  }
}


async ensureCartHasItem(variantId) {
  if (!variantId) throw new Error('Variant ID inválido.');

  let cart;
  try {
    cart = await fetch('/cart.js').then(r => r.json());
  } catch {
    throw new Error('Erro ao acessar o carrinho.');
  }

  const alreadyInCart = cart.items.some(i => i.variant_id == variantId);
  if (alreadyInCart) return;

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: Number(variantId), quantity: 1 })
  });

  if (!res.ok) throw new Error('Não foi possível adicionar o produto ao carrinho.');
}


renderRates(rates) {
  if (!rates || rates.length === 0) {
    this.showError('Nenhuma opção de frete disponível para este CEP.');
    return;
  }

  // Filtra retirada em loja separadamente
  const pickup = rates.filter(r => r.price === '0.00' && r.source === 'shopify');
  const delivery = rates.filter(r => !(r.price === '0.00' && r.source === 'shopify'));

  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    const [y, m, d] = dateStr.split('-');
    return `${d}/${m}/${y}`;
  };

  const formatDays = (days) => {
    if (!days || days.length === 0) return null;
    const d = days[0];
    return d === 1 ? '1 dia útil' : `${d} dias úteis`;
  };

  const renderRate = (rate) => `
    <div class="shipping-rate">
      <div class="shipping-rate__info">
        <span class="shipping-rate__name">${rate.presentment_name.trim()}</span>
        ${formatDays(rate.delivery_days)
          ? `<span class="shipping-rate__days">${formatDays(rate.delivery_days)}</span>`
          : ''}
      </div>
      <div class="shipping-rate__right">
        <span class="shipping-rate__price">${this.formatPrice(rate.price)}</span>
        ${formatDate(rate.delivery_date)
          ? `<span class="shipping-rate__date">até ${formatDate(rate.delivery_date)}</span>`
          : ''}
      </div>
    </div>
  `;

  const pickupHtml = pickup.length ? `
    <div class="shipping-pickup">
      <span class="shipping-pickup__icon">🏪</span>
      <span class="shipping-pickup__text">Retirada grátis disponível</span>
    </div>
  ` : '';

  this.result.innerHTML = `
    <div class="shipping-rates">
      ${pickupHtml}
      ${delivery.map(renderRate).join('')}
    </div>
  `;
}

formatPrice(price) {
  const value = parseFloat(price);
  return value === 0
    ? '<strong>Grátis</strong>'
    : `R$ ${value.toFixed(2).replace('.', ',')}`;
}


  formatPrice(price) {
    // A API retorna o preço como string em centavos (ex: "1500" = R$ 15,00)
    const value = parseFloat(price);
    return value === 0
      ? 'Grátis'
      : `R$ ${value.toFixed(2).replace('.', ',')}`;
  }

  showLoading() {
    this.result.innerHTML = '<p class="shipping-loading">Calculando...</p>';
  }

  showError(msg) {
    this.result.innerHTML = `<p class="shipping-error">${msg}</p>`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.__shippingCalculatorInit) return; // ← guard
  window.__shippingCalculatorInit = true;
  new ShippingCalculator();
});
